/**
 * 红包定义
 * @constructor
 */
import {HongDefine} from "./HongPrizeConfig";

export function NewGglPrize() : HongDefine[]{
    const dataList : HongDefine[] = [
        {
            uniqueId : "1",
            name : "500元",
            prize : 500,
            appearWeight : 1000,
            weight:7900,
        },
        {
            uniqueId : "2",
            name : "2023元",
            prize : 2023,
            appearWeight : 1200,
            weight : 3000,
        },
        {
            uniqueId : "3",
            name : "1.1万",
            prize : 11000,
            appearWeight : 1400,
            weight : 2500,
        },
        {
            uniqueId : "4",
            name : "10w",
            prize : 100000,
            appearWeight : 1300,
            weight : 2000,
        },
        {
            uniqueId : "5",
            name : "68万",
            prize : 680000,
            appearWeight : 1400,
            weight : 1500,
        },
        {
            uniqueId : "6",
            name : "188万",
            prize : 1880000,
            appearWeight : 1400,
            weight : 1000,
        },
        {
            uniqueId : "7",
            name : "666万",
            prize : 6660000,
            appearWeight : 1300,
            weight : 500,
        },
        {
            uniqueId : "8",
            name : "888万",
            prize : 8880000,
            appearWeight : 1000,
            weight : 300,
        },
    ];
    return dataList;
}

/**
 * 获取随机
 */
export function getNewGglPrize() : HongDefine{
    let retData : HongDefine = null;
    const dataList = NewGglPrize();
    let randomNum = Math.floor( Math.random() * 10000 );
    for ( let item of dataList ) {
        if ( randomNum <= item.appearWeight ) {
            retData = item;
            break;
        }
        randomNum -= item.appearWeight;
    }
    return retData;
}
